import React, { useEffect, useRef } from 'react';
import Message from './Message';
import './MessageList.css';
import { assetUrl } from '@/utils/assetUrl';
const agentAvatarIcon = assetUrl('/assets/agent.svg');

// Same rationale as Message.jsx: in widget/embed modes the host page's
// generic CSS (e.g. `div { padding: 0 }` resets) can leak into the typing
// indicator. Inline styles win, so we reapply the key visual rules there.
const TYPING_INLINE_STYLES = {
  wrapper: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '70%',
    alignSelf: 'flex-start',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  avatar: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: 'transparent',
  },
  avatarIcon: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  indicator: {
    display: 'flex',
    gap: '6px',
    padding: '12px 16px',
    background: '#F6F6F7',
    borderRadius: '10px',
    width: 'fit-content',
    border: '1px solid #E3E3E3',
  },
  dot: {
    width: '8px',
    height: '8px',
    background: '#999',
    borderRadius: '50%',
  },
};

const MessageList = ({ messages, isLoading, isConnecting, agentState = 'listening', onClickableTextClick, lang = 'ar', isWidget = false }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Show typing indicator when:
  // - Agent is thinking or speaking
  // - OR when no messages yet (initial state)
  // - OR when explicitly loading
  const shouldShowTyping = (
    agentState === 'thinking' ||
    agentState === 'speaking' ||
    isLoading ||
    messages.length === 0
  );

  const typingStyles = isWidget ? TYPING_INLINE_STYLES : null;

  return (
    <div className="message-list">
      {messages.map((msg) => (
        <Message
          key={msg.id}
          message={msg}
          isUser={msg.sender === 'user'}
          onClickableTextClick={onClickableTextClick}
          lang={lang}
          isWidget={isWidget}
        />
      ))}
      {shouldShowTyping && (
        <div className="typing-indicator-wrapper" style={typingStyles?.wrapper}>
          <div className="typing-indicator-header" style={typingStyles?.header}>
            <div className="typing-avatar" style={typingStyles?.avatar}>
              <img src={agentAvatarIcon} alt="Agent" className="agent-avatar-icon" style={typingStyles?.avatarIcon} />
            </div>
          </div>
          <div className="typing-indicator" style={typingStyles?.indicator}>
            <div className="typing-dot" style={typingStyles?.dot}></div>
            <div className="typing-dot" style={typingStyles?.dot}></div>
            <div className="typing-dot" style={typingStyles?.dot}></div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
